import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Container,
  LoadingSpinner,
  LoadingSpinnerPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/loading-spinner.scss';

export type NcLoadingSpinnerT = React.FC<LoadingSpinnerPropsT & {
  className?: string;
}>;

const defaultClasses = [
  'nc-loading-spinner',
  'align-items-center',
  'd-flex',
  'flex-column',
  'justify-content-center',
].join(' ');

export const NcLoadingSpinner: NcLoadingSpinnerT = ({
  className,
  ...props
}) => {
  const cssClasses = mergeClassNameStrings(
    className,
    defaultClasses,
  );

  return (
    <Container className={cssClasses}>
      <LoadingSpinner {...props} />
    </Container>
  );
};
